import React, { FC, useCallback } from "react";
import { useTranslation } from "react-i18next";

import { Header } from "@/components/Header";
import { Text } from "@/components/Text";
import { Flex } from "@/eworkitComponents";
import { AnimatedLayoutContainer } from "@/views/components/Layout";

import { InvitationRolePickerBox } from "../InvitationRolePickerBox";
import { InvitationAccountType } from "./types";

interface IInvitationAccountPickerProps {
  onAccountTypeSelected: (type: InvitationAccountType) => void;
}

export const InvitationAccountPicker: FC<IInvitationAccountPickerProps> = ({ onAccountTypeSelected }) => {
  const { t } = useTranslation("public");

  const handleCreateNewAccountClick = useCallback(() => {
    onAccountTypeSelected("new");
  }, [onAccountTypeSelected]);

  const handleAddToExistingClick = useCallback(() => {
    onAccountTypeSelected("existing");
  }, [onAccountTypeSelected]);

  return (
    <AnimatedLayoutContainer size="md" showLogo>
      <Flex direction="column" justify="center" innerMargin="lg">
        <Header align="center" weight="bold" size="lg">
          {t("SESSION_INVITATION.CREATE_PROFILE_HEADER")}
        </Header>
        <Text align="center" size="lg">
          {t("SESSION_INVITATION.CREATE_PROFILE_TEXT")}
        </Text>

        <Flex direction="column" innerMargin="md">
          <InvitationRolePickerBox
            header={t("SESSION_INVITATION.CREATE_NEW_ACCOUNT_HEADER")}
            description={t("SESSION_INVITATION.CREATE_NEW_ACCOUNT_TEXT")}
            icon="user"
            onClick={handleCreateNewAccountClick}
          />
          <InvitationRolePickerBox
            header={t("SESSION_INVITATION.ADD_TO_EXISTING_HEADER")}
            description={t("SESSION_INVITATION.ADD_TO_EXISTING_TEXT")}
            icon="content_copy"
            onClick={handleAddToExistingClick}
          />
        </Flex>
      </Flex>
    </AnimatedLayoutContainer>
  );
};
